export default __webpack_public_path__ + "static/media/venkobarao-srinivas.3c47846b.png";